import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ Import navigate
import './LoginForm.css';

const LoginForm = ({ setIsLoggedIn }) => { // ✅ Accept setIsLoggedIn as prop
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate(); // ✅ useNavigate hook

  const handleLogin = (e) => {
    e.preventDefault();

    // Hardcoded credentials
    const adminId = 'admin';
    const adminPass = '@Vroomfy0614';

    if (userId === adminId && password === adminPass) {
      sessionStorage.setItem('isLoggedIn', 'true'); // ✅ Save login status
      setIsLoggedIn(true);  // ✅ Update React state
      setMessage('✅ Login successful!');
      setTimeout(() => {
        navigate('/categories'); // ✅ Redirect without reload
      }, 1000);
    } else {
      setMessage('❌ Invalid ID or Password.');
    }
  };

  return (
    <div className="login-container d-flex justify-content-center align-items-center vh-100">
      <div className="login-box text-center p-4 rounded-4 shadow">
        <h2 className="text-white mb-4">Admin Login</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control custom-input"
              placeholder="Admin ID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              className="form-control custom-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn custom-btn">Login</button>
          {message && <div className="mt-3 text-white fw-bold">{message}</div>}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
